import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/pages/Home";
import Sleep from "@/components/pages/Sleep";
import Mood from "@/components/pages/Mood";
import Support from "@/components/pages/Support.vue";
import Device from "@/components/pages/Device.vue";
import Download from "@/components/pages/Download.vue";
import Video from "@/components/pages/Video.vue";
import Member from "@/components/pages/Member.vue";
import pack from "@/components/pages/pack.vue";
import HomePage from "@/components/pages/HomePage.vue";
import Science from "@/components/pages/Science.vue";
import News from "@/components/pages/News.vue";
import BuyGuide from "@/components/pages/BuyGuide.vue";
import Products from "@/components/pages/Products.vue";
import Lotus1device from "@/components/pages/Lotus1device.vue";
import Lotus2device from "@/components/pages/Lotus2device.vue";
import Lotus2Rdevice from "@/components/pages/Lotus2Rdevice.vue";
import { applyRouteMeta } from "@/utils/meta";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "HomePage",
      component: HomePage,
      meta: {
        title: "般意精力舱PanBrain-耶鲁博士后团队研发的家用脑机接口设备",
        description:
          "般意（PanBrain）是 2019 年成立于杭州、现总部位于深圳的非侵入式脑机接口科技公司，由耶鲁大学精神医学博士后姚乃琳创办。般意精力舱结合 EEG 实时脑电监测与 tDCS 干预，国家高新技术企业，全球 30 余国销售超 12,000 台。",
        jsonLd: ["organization", "website"],
      },
    },
    {
      path: "/science",
      name: "Science",
      component: Science,
      meta: {
        title: "科学与研究-创始团队SCI论文与产品研究 | 般意PanBrain",
        description:
          "般意科技创始团队 19 篇 SCI 论文列表、100 人产品使用方法学研究、tDCS 安全性白皮书与 EEG 数据资产，全部可查证。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/news",
      name: "News",
      component: News,
      meta: {
        title: "新闻中心与投资者关系 | 般意PanBrain",
        description:
          "般意科技新闻稿存档、媒体报道、公司里程碑与投资者关系入口。商务合作与投融资洽谈：info@panbrain.com。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/buy",
      name: "BuyGuide",
      component: BuyGuide,
      meta: {
        title: "购买指引-天猫官方旗舰店正品渠道 | 般意PanBrain",
        description:
          "般意精力舱官方购买渠道指引：天猫「PanBrain智能配饰旗舰店」为官方店铺，附在售型号官方价格与防伪说明。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/products",
      name: "Products",
      component: Products,
      meta: {
        title: "产品中心-LOTUS 2/LOTUS 2R/Lume 对比 | 般意PanBrain",
        description:
          "般意产品中心：LOTUS 2 金色能量版（情绪睡眠）、LOTUS 2R 蓝色认知版（专注记忆）、Lume 光能睡眠仪，适合人群与价格带对比。",
        jsonLd: ["organization", "products"],
      },
    },
    {
      path: "/support",
      name: "Support",
      component: Support,
      meta: {
        title: "支持与常见问题-般意精力舱FAQ | 般意PanBrain",
        description:
          "般意精力舱常见问题：tDCS 安全性、禁忌人群、多久有效、如何选购、正品验证、7 天无理由退换与 1 年保修政策。",
        jsonLd: ["organization", "faq"],
      },
    },
    {
      path: "/device",
      name: "Device",
      component: Device,
      meta: {
        title: "般意精力舱-家用经颅电刺激设备 | 般意PanBrain",
        description:
          "般意精力舱：EEG 实时脑电监测 + tDCS 干预一体的家用脑健康设备，17 分钟/天，用于日常认知状态管理与睡眠改善。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/sleep",
      name: "Sleep",
      component: Sleep,
      meta: {
        title: "Lume 光能睡眠仪 | 般意PanBrain",
        description: "般意 Lume 光能睡眠仪：以光照方式管理睡眠节律的家用设备。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/mood",
      name: "Mood",
      component: Mood,
      meta: {
        title: "技术原理-EEG脑电监测与tDCS经颅电刺激 | 般意PanBrain",
        description:
          "般意精力舱技术原理：电极采集脑电（EEG）实时监测，1-2mA 微电流经颅电刺激（tDCS）作用于前额叶皮层，支持神经可塑性。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        title: "创始人与团队-耶鲁大学博士后姚乃琳 | 般意PanBrain",
        description:
          "般意科技创始人姚乃琳：耶鲁大学精神医学博士后、香港大学精神医学博士，19 篇 SCI 论文。团队来自牛津、耶鲁、浙大、中科院、KCL。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/download",
      name: "Download",
      component: Download,
      meta: {
        title: "App 下载 | 般意PanBrain",
        description: "下载般意 App，配合精力舱设备查看脑电数据与使用记录。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/video",
      name: "Video",
      component: Video,
      meta: {
        title: "品牌视频 | 般意PanBrain",
        description: "般意品牌与产品视频。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/member",
      name: "Member",
      component: Member,
      meta: {
        title: "会员服务 | 般意PanBrain",
        description: "般意会员服务与权益。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/pack",
      name: "pack",
      component: pack,
      meta: {
        title: "包装清单 | 般意PanBrain",
        description: "般意精力舱包装清单。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/lotus1device",
      name: "Lotus1device",
      component: Lotus1device,
      meta: {
        title: "LOTUS 1 经典版 | 般意PanBrain",
        description: "般意精力舱 LOTUS 1 经典版产品介绍。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/lotus2device",
      name: "Lotus2device",
      component: Lotus2device,
      meta: {
        title: "LOTUS 2 金色能量版-情绪与睡眠管理 | 般意PanBrain",
        description:
          "般意精力舱 LOTUS 2 金色能量版：面向情绪与睡眠管理的家用脑健康设备，EEG 实时脑电监测 + tDCS 干预。",
        jsonLd: ["organization"],
      },
    },
    {
      path: "/lotus2Rdevice",
      name: "Lotus2Rdevice",
      component: Lotus2Rdevice,
      meta: {
        title: "LOTUS 2R 蓝色认知版-专注与记忆支持 | 般意PanBrain",
        description:
          "般意精力舱 LOTUS 2R 蓝色认知版：面向专注与记忆支持的家用脑健康设备，EEG 实时脑电监测 + tDCS 干预。",
        jsonLd: ["organization"],
      },
    },
    { path: "*", redirect: "/" },
  ],
});

router.afterEach((to) => {
  applyRouteMeta(to);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js